module.exports = __webpack_public_path__ + "files/9ee02c8ae925e8c57817f43125928d02.svg";